import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import { TranslateService } from '@ngx-translate/core';

import {
  NavigationOption,
  NavigationService,
} from '../../navigation/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class NavigateDoActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'navigate-do';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private translate: TranslateService,
    private appParameterService: AppParameterService,
    private navigationService: NavigationService
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    let complat = this.appParameterService.appParameters$.getValue().complat;

    let complon = this.appParameterService.appParameters$.getValue().complon;

    const target: NavigationOption = {};
    target.name = this.appParameterService.appParameters$.getValue().compname;

    if (complat && complon) {
      target.coords = {
        latitude: complat,
        longitude: complon,
      };
    } else {
      target.addr =
        (this.appParameterService.appParameters$.getValue()?.compcity ?? '') +
        ', ' +
        (this.appParameterService.appParameters$.getValue()?.compfullstreet ??
          '');
    }
    this.navigationService.navigateTo(target);
  }

  // Private Functions
}
